import React from "react";
import SignUp from "../components/Landing/SignUp";

const SignUpPage = () => {
  return <SignUp />;
};

export default SignUpPage;
